module.exports = wp.domReady;